import { IconButton } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import cn from 'classnames'
import { Draggable } from 'react-beautiful-dnd'
import styled from 'styled-components'

import theme from '../../utils/theme'
import Icon from '../Icon'

const styles = theme => ({
  wrapper: {
    display: 'flex',
    width: props => (props.customWidth ? props.customWidth : '100%'),
    minHeight: '36px',
    borderRadius: '4px',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    marginTop: 12,
    '& + &': {},
    '& .content-wrapper': {
      padding: '0 !important',
    },
  },
  wrapperIsImage: {
    position: 'relative',
    margin: '0 8px 8px 0',
  },
  itemWrap: {
    '&.fullWidth': {
      width: '100%',
    },
    '&.willDelete': {
      textDecoration: 'line-through',
      opacity: 0.6,
    },
  },
  item: {
    display: 'inline-flex',
    alignItems: 'center',
    width: '260px',
    height: '36px',
    padding: '0 8px',
    borderRadius: '4px',
    border: `1px solid ${`var(--gameday-inputField-inputBorder, ${theme.inputField.inputBorder})`}`,
    backgroundColor: theme.inputField.inputBGColorActive,
    fontSize: theme.typography.fontSizeSm,
    color: `var(--gameday-body-textColor, ${theme.body.textColor})`,
  },
  label: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  dragAndLabel: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
  },
  icon: {
    color: `var(--gameday-body-textColorAlt, ${theme.body.textColorAlt})`,
  },
  dragIcon: {
    fill: `var(--gameday-body-textColorAlt, ${theme.body.textColorAlt})`,
    display: 'block',
    marginRight: '8px',
  },
  buttonContainer: {
    justifySelf: 'center',
    justifyContent: 'center',
    margin: '0 8px',
  },
  isImage: {
    position: 'absolute',
    bottom: '18px',
    right: '0',
    zIndex: '1',
  },
  button: {
    fontSize: '1rem',
    height: '36px',
    width: '36px',
    padding: '4px',
    '> svg': {
      height: '36px',
    },
  },
  noProgress: {
    width: 20,
    height: 20,
    right: 0,
    bottom: 15,
    '& $button': {
      width: 24,
      height: 24,
      padding: 2,
    },
  },
  isDeletable: {
    paddingRight: '52px',
  },
  gridView: {
    height: '100%',
    '& $dragAndLabel, & $itemWrap, & .label-wrapper, & .content-wrapper, & .wrapped, & .field-col': {
      width: '100%',
      height: '100%',
    },
  },
})

const Item = styled.div`
  background-color: ${props => props.isDragging && `var(--gameday-table-rowDragBg, ${theme.table.rowDragBg})`};
  box-shadow: ${props => props.isDragging && '1px 1px 3px 0px rgba(204,204,204,1)'};
`

const ListItemDraggable = ({
  children,
  classes,
  customWidth,
  deletable,
  draggable,
  draggableId,
  fullWidth,
  handleDelete,
  index,
  isGrid,
  isImage,
  key,
  // biome-ignore lint/correctness/noUnusedFunctionParameters: TODO
  multipleDirection,
  showProgress,
  willDelete,
}) => (
  <Draggable key={key} draggableId={draggableId} index={index} isDragDisabled={!draggable}>
    {(provided, snapshot) => (
      <Item
        className={cn(classes.wrapper, {
          [classes.wrapperIsImage]: isImage,
          [classes.gridView]: isGrid,
          [classes.isDeletable]: !deletable,
        })}
        ref={provided.innerRef}
        isDragging={snapshot.isDragging}
        style={customWidth && { width: customWidth }}
        {...provided.draggableProps}
        {...provided.dragHandleProps}
      >
        <div className={classes.dragAndLabel}>
          {draggable && <Icon iconName="fieldDragHandle" iconSize="10" className={classes.dragIcon} />}
          <div className={cn({ fullWidth, willDelete }, classes.itemWrap, 'draggable-item')}>{children}</div>
        </div>
        {deletable && (
          <div
            className={cn(classes.buttonContainer, {
              [classes.isImage]: isImage,
              [classes.noProgress]: !showProgress,
            })}
          >
            <IconButton classes={{ root: classes.button }} onClick={handleDelete} aria-label="Delete">
              <Icon iconSize={isImage ? 18 : 22} iconName="delete" color={willDelete && 'red'} />
            </IconButton>
          </div>
        )}
      </Item>
    )}
  </Draggable>
)

ListItemDraggable.defaultProps = {
  showProgress: true,
}

const ListItemDraggableComponent = withStyles(styles)(ListItemDraggable)
ListItemDraggableComponent.displayName = 'ListItemDraggable'
export default ListItemDraggableComponent
